import React, { useMemo } from "react";
import { useTheme } from "@mui/material";
import "./ScrollingLogos.css";
import ColoredLogo from "./ColoredLogo";

const MIN_LOGO_COUNT = 12;

const ScrollingLogos = ({ logos = [] }) => {
  const theme = useTheme();
  const repeatedLogos = useMemo(() => {
    if (!logos.length) return [];
    const timesToRepeat = Math.ceil(MIN_LOGO_COUNT / logos.length);
    const extended = Array(timesToRepeat).fill(logos).flat();
    return [...extended, ...extended];
  }, [logos]);

  if (!repeatedLogos.length) return null;

  return (
    <div className="scrolling-logos-container">
      <div className="scrolling-logos-track">
        {repeatedLogos.map((logo, index) => (
          <div key={index} className="scrolling-logo">
            <ColoredLogo
              src={logo}
              color={theme.palette.mode === "dark" ? "#ddd" : "#333"}
              size={86}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ScrollingLogos;
